import { render, staticRenderFns } from "./HaberKategori.vue?vue&type=template&id=53a3911b&scoped=true&"
import script from "./HaberKategori.vue?vue&type=script&lang=js&"
export * from "./HaberKategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3911b",
  null
  
)

export default component.exports